module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "audio"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.audio.title,
      "level": 2,
      "font": "oswald",
      "color": "yellow",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('large-picture', {
    attrs: {
      "src": _vm.audio.picture,
      "alt": _vm.audio.title
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.audio.player)
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6495120d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Audio.vue
// module id = 262
// module chunks = 0